import React from "react";
import { Quote } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { FadeUp, SectionHeader } from "@/components/ui-primitives";

const TestimonialsSection = () => {
  const { t } = useLanguage();
  const items = t.home.testimonials || [];

  return (
    <section
      className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 bg-bone"
      data-testid="home-testimonials"
    >
      <SectionHeader
        eyebrow={t.home.testimonialsEyebrow}
        title={t.home.testimonialsTitle}
        subtitle={t.home.testimonialsSubtitle}
      />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-navy/10">
        {items.map((it, i) => (
          <FadeUp key={i} delay={i * 0.08}>
            <article
              className="bg-bone hover:bg-cream transition-colors p-10 h-full flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Quote
                size={28}
                strokeWidth={1.25}
                className="text-brand mb-6 shrink-0"
              />
              <p className="font-display text-lg sm:text-xl text-navy leading-snug italic mb-8">
                "{it.quote}"
              </p>
              <div className="mt-auto">
                <div className="gold-rule mb-4" />
                <div className="text-[11px] tracking-[0.25em] uppercase text-navy/85 font-semibold">
                  {it.role}
                </div>
                <div className="mt-1 text-[11px] tracking-[0.15em] uppercase text-navy/45">
                  {it.flag}
                </div>
              </div>
            </article>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
